import React, { useState } from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import Img from 'gatsby-image';
import { PlayIcon } from '@kespa/ui';

const Wrap = styled.div`
    display: flex;
    padding-bottom: 10rem;
    @media screen and (max-width: 760px) {
        display: block;
        padding-bottom: 0;
    }
`;

const PromoVideoBlock = styled.div`
    display: inline-block;
    width: 100%;
    position: relative;
    box-shadow: 10px 15px 50px -5px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    overflow: hidden;
    cursor: pointer;
    transition: 0.3s ease 0s;
    &:hover {
        box-shadow: 10px 15px 100px -5px rgba(0, 0, 0, 0.2);
        svg {
            fill: #0dbdfc;
        }
    }

    & iframe {
        position: absolute;
        top: 0;
        left: 0;
    }
    @media screen and (max-width: 760px) {
        min-width: 100%;
    }
`;

const CoverWrap = styled.div`
    display: block;
    position: relative;
    width: 100%;
`;

const PlayButton = styled.div`
    width: 20%;
    height: 20%;
    position: absolute;
    top: 8%;
    right: 5%;

    svg {
        position: relative;
        width: 100%;
        height: 100%;
        transition: 0.3s ease 0s;
    }
`;

const TextWrap = styled.div`
    display: inline-block;
    position: relative;
    max-width: 50%;
    margin: auto 10%;

    @media screen and (max-width: 1024px) {
        margin: auto 5%;
    }
    @media screen and (max-width: 760px) {
        max-width: 100%;
        margin: 5% 0;
    }
`;

export const PromoVideo = ({ youtubeID, children }) => {
    const data = useStaticQuery(graphql`
        query ImageQuery {
            file(relativePath: { eq: "main/promo-video-cover.png" }) {
                childImageSharp {
                    fluid(maxWidth: 669) {
                        ...GatsbyImageSharpFluid_noBase64
                    }
                }
            }
        }
    `);

    const [videoLoad, setVideoLoad] = useState(false);
    const onClick = () => {
        setVideoLoad(true);
    };
    const video = videoLoad ? (
        <iframe
            title="Инна Гивенталь о стереотипах в изучени английского языка"
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${youtubeID}?autoplay=1`}
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        />
    ) : (
        <PlayButton onClick={onClick}>
            <PlayIcon />
        </PlayButton>
    );
    return (
        <Wrap>
            <PromoVideoBlock>
                <CoverWrap onClick={onClick}>
                    <Img fluid={data.file.childImageSharp.fluid} />
                </CoverWrap>
                {video}
            </PromoVideoBlock>
            <TextWrap>{children}</TextWrap>
        </Wrap>
    );
};
